/// <amd-module name="typeahead/core/SuggestionModifier" />

import {ConfigurableFeature} from "ConfigurableFeature";
import {IOverrideParams} from "typeahead/core/IOverrideParams";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";

export abstract class SuggestionModifier extends ConfigurableFeature {
    protected modifySuggestions(suggestions: Object[], context: IContext, options: IOverrideParams):
            JQueryPromise<Object[]> {
        let deferred: JQueryDeferred<Object[]> = $.Deferred();
        this.shouldOverride(options)
            .done((shouldExecute) => {
                if (shouldExecute) {
                    this.modify(suggestions, context);
                }
                deferred.resolve(suggestions);
            })
            .fail(() => {
                if (this.precondition(suggestions, context)) {
                    ExecutionHelper.shouldExecute(context, this.configuration)
                        .done((shouldExecute) => {
                            if (shouldExecute) {
                                this.modify(suggestions, context);
                            }
                            deferred.resolve(suggestions);
                        });
                } else {
                    deferred.resolve(suggestions);
                }
            });
        return deferred.promise();
    }
    protected precondition(suggestions: any, context: IContext) {
        return suggestions && suggestions.length > 0;
    }
    protected abstract modify(suggestions: any, context: IContext);
}
